<xform-page *ngIf="authenticationService.isLoggedIn()" [bgColor]="'white-bg'">
  <div class="text-center">
    <h1 class="m-top-100">Compliance Calendar Integration</h1>
  </div>

  <div style="display: flex">
    <div style="flex: 1; border: 1px solid black;">
      <cci-saved-queries-panel></cci-saved-queries-panel>
    </div>
    <div style="flex: 1; border: 1px solid black;">
      <cci-search-panel></cci-search-panel>
    </div>
    <div style="flex: 1; border: 1px solid black;">
      <cci-email-panel></cci-email-panel>
    </div>
  </div>

  <cci-result-panel></cci-result-panel>
</xform-page>
